var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-custom-card h100 flex flex-col"},[_c('div',{staticClass:"custom-title"},[_c('span',{staticClass:"title-box"},[_vm._v(" "+_vm._s(_vm.customTitle)+" ")]),_vm._t("header-btns")],2),_c('div',{staticClass:"custom-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }